import { Input } from '@/shared/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select';
import { Search } from 'lucide-react';
import { CONTRACT_STATUSES, ContractStatus } from '../utils/types';
import { getStatusLabel } from '../utils/contractStatus';

interface ContractFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  statusFilter: ContractStatus | 'all';
  onStatusFilterChange: (value: ContractStatus | 'all') => void;
  includeDeleted: boolean;
  onIncludeDeletedChange: (value: boolean) => void;
}

export const ContractFilters = ({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  includeDeleted,
  onIncludeDeletedChange,
}: ContractFiltersProps) => {
  const statusOptions = CONTRACT_STATUSES.filter(
    (status) => status.toUpperCase() === status
  ) as ContractStatus[];

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center">
      {/* Busca por nome */}
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Buscar por nome do creator..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9"
        />
      </div>

      {/* Filtro por status */}
      <Select
        value={statusFilter}
        onValueChange={(value) => onStatusFilterChange(value as ContractStatus | 'all')}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos os status</SelectItem>
          {statusOptions.map((status) => (
            <SelectItem key={status} value={status}>
              {getStatusLabel(status)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Toggle de contratos excluídos */}
      <Select
        value={includeDeleted ? 'true' : 'false'}
        onValueChange={(value) => onIncludeDeletedChange(value === 'true')}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="false">Sem excluídos</SelectItem>
          <SelectItem value="true">Com excluídos</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
